export default {
  'pages.layouts.userLayout.title':
    'Ant Designは、西湖区で最も影響力のあるWebデザイン仕様です。',
  'pages.login.accountLogin.tab': 'アカウントログイン',
  'pages.login.accountLogin.errorMessage':
    'ユーザー名/パスワードが正しくありません(admin/ant.design)',
  'pages.login.failure': 'ログインに失敗したら、もう一度試してください!',
  'pages.login.success': 'ログイン成功!',
  'pages.login.username.placeholder': 'ユーザー名：adminまたはuser',
  'pages.login.username.required': 'ユーザー名を入力してください！',
  'pages.login.password.placeholder': 'パスワード：ant.design',
  'pages.login.password.required': 'パスワードを入力してください！',
  'pages.login.phoneLogin.tab': '電話ログイン',
  'pages.login.phoneLogin.errorMessage': '検証コードエラー',
  'pages.login.phoneNumber.placeholder': '電話番号',
  'pages.login.phoneNumber.required': '電話番号を入力してください！',
  'pages.login.phoneNumber.invalid': '電話番号が無効です！',
  'pages.login.captcha.placeholder': '確認コード',
  'pages.login.captcha.required': '確認コードを入力してください！',
  'pages.login.phoneLogin.getVerificationCode': '確認コードを取得',
  'pages.getCaptchaSecondText': '秒',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'パスワードをお忘れですか？',
  'pages.login.submit': 'ログイン',
  'pages.login.loginWith': 'その他のログイン方法：',
  'pages.login.registerAccount': 'アカウント登録',
  'pages.login.welcome': 'インテリジェントビデオ処理プラットフォームへようこそ',
  'pages.welcome.link': 'ようこそ',
  'pages.welcome.alertMessage':
    'より高速で強力な頑丈なコンポーネントがリリースされました。',
  'pages.404.subTitle':
    '申し訳ありませんが、アクセスしたページは存在しません。',
  'pages.404.buttonText': 'ホームに戻る',
  'pages.admin.subPage.title': 'このページは管理者のみが表示できます',
  'pages.admin.subPage.alertMessage':
    'Umi uiがリリースされました。npm run uiを使用して体験してください。',
  'pages.searchTable.createForm.newRule': '新しいルール',
  'pages.searchTable.updateForm.ruleConfig': 'ルール構成',
  'pages.searchTable.updateForm.basicConfig': '基本情報',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'ルール名',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'ルール名を入力してください！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'ルールの説明',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    '5文字以上入力してください',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '5文字以上のルールの説明を入力してください！',
  'pages.searchTable.updateForm.ruleProps.title': 'プロパティの構成',
  'pages.searchTable.updateForm.object': '監視対象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'ルールテンプレート',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'ルールタイプ',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'スケジュール期間の設定',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    '開始時間を選択してください！',
  'pages.searchTable.titleDesc': '説明',
  'pages.searchTable.ruleName': 'ルール名が必要です',
  'pages.searchTable.titleCallNo': 'サービスコール数',
  'pages.searchTable.titleStatus': 'ステータス',
  'pages.searchTable.nameStatus.default': 'デフォルト',
  'pages.searchTable.nameStatus.running': '起動中',
  'pages.searchTable.nameStatus.online': 'オンライン',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '最終スケジュール',
  'pages.searchTable.exception': '例外の理由を入力してください！',
  'pages.searchTable.titleOption': 'オプション',
  'pages.searchTable.config': '構成',
  'pages.searchTable.subscribeAlert': 'アラートを購読する',
  'pages.searchTable.title': 'お問い合わせフォーム',
  'pages.searchTable.new': '新しい',
  'pages.searchTable.chosen': '選んだ項目',
  'pages.searchTable.item': '項目',
  'pages.searchTable.totalServiceCalls': 'サービスコールの総数',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': 'バッチ削除',
  'pages.searchTable.batchApproval': 'バッチ承認',
  'pages.employee.management': '従業員管理',
  'pages.employee.new': '新規従業員',
  'pages.employee.detail': '詳細',
  'pages.employee.edit': '編集',
  'pages.employee.delete': '削除',
  'pages.employee.deleteConfirm': '本当に削除しますか？',
  'pages.employee.okText': 'OK',
  'pages.employee.cancelText': 'キャンセル',
  'pages.employee.deleteSuccess': '削除しました',
  'pages.employee.deleteFailed': '削除に失敗しました',
  'pages.employee.fetchDetailFailed': '詳細の取得に失敗しました',
  'pages.employee.createTitle': '従業員を作成',
  'pages.employee.editTitle': '従業員を編集',
  'pages.employee.detailTitle': '従業員詳細',
  'pages.employee.updatedSuccessfully': '更新しました',
  'pages.employee.createdSuccessfully': '作成しました',
  'pages.employee.updateFailed': '更新に失敗しました。再試行してください',
  'pages.employee.createFailed': '作成に失敗しました。再試行してください',
  'pages.employee.employeeNumber': '社員番号',
  'pages.employee.name': '氏名',
  'pages.employee.organization': '組織',
  'pages.employee.department': '部署',
  'pages.employee.position': '役職',
  'pages.employee.role': 'ロール',
  'pages.employee.status': 'ステータス',
  'pages.employee.active': '有効',
  'pages.employee.inactive': '無効',
  'pages.employee.remark': '備考',
  'pages.employee.namePlaceholder': '氏名を入力してください!',
  'pages.employee.employeeId': '社員ID',
  'pages.employee.employeeIdPlaceholder': '社員IDを入力してください',
  'pages.employee.selectDepartment': '部署を選択してください',
  'pages.employee.selectPosition': '役職を選択してください',
  'pages.employee.operation': '操作',
  'pages.employee.deleteConfirmContent':
    'この従業員を削除してもよろしいですか？',

  // デバイス管理モジュール国際化
  'pages.device.management': 'デバイス管理',
  'pages.device.gateway': 'ゲートウェイ',
  'pages.device.terminal': 'ターミナル',
  'pages.device.noData': 'デバイスデータなし',
  'pages.device.noDataDescription':
    '現在デバイスデータがありません。まずゲートウェイデバイスを作成してください',
  'pages.device.createGateway': 'ゲートウェイを作成',
  'pages.device.refresh': '更新',
  'pages.device.viewDetails': '詳細を表示',
  'pages.device.online': 'オンライン',
  'pages.device.offline': 'オフライン',
  'pages.device.hasChild': '子デバイスあり',
  'pages.device.noChild': '子デバイスなし',
};
